var login = {
  translation: {
    common: {
      accept: 'Přijmout',
      alreadyUser: 'Již máte účet?',
      and: 'a',
      backToLogin: 'Zpět na přihlašovací stránku',
      continueWith: 'Pokračovat s {{provider}}',
      createAccount: 'Vytvořit účet',
      createYourAccount: 'Vytvořte si účet',
      emailOrUsername: 'E-mail nebo uživatelské jméno',
      login: 'Přihlásit se',
      logInToBoards: 'Přihlásit se',
      newToBoards: 'Nový v 4ga Boards?',
      pageNotFound_title: 'Stránka nenalezena',
      password: 'Heslo',
      privacyPolicy: 'Zásady ochrany osobních údajů',
      register: 'Registrovat',
      registerWithGoogle: 'Registrovat přes Google',
      termsOfService: 'Podmínky služby',
      togglePasswordVisibility: 'Zobrazit/skrýt heslo',
    },

    action: {
      logIn: 'Přihlásit se',
    },
  },
};

export { login as default };
